import _ from 'lodash';

class Document {
  constructor() {
    this.delegate = {};
    this.init();
  }

  init() {
    document.addEventListener('click', () => {
      /* eslint-disable no-unused-vars */
      _.each(this.delegate, (list, key) => {
        _.each(list, func => {
          if (func) {
            func();
          }
        });
      });
      /* eslint-enable no-unused-vars */
    });
  }

  setDelegate(key, func) {
    if (_.has(this.delegate, key)) {
      this.delegate[key].push(func);
    } else {
      this.delegate[key] = [];
      this.delegate[key].push(func);
    }
  }

  removeDelegate(key) {
    this.delegate[key] = [];
    delete this.delegate[key];
  }
}

const DocumentDelegate = new Document();
export default DocumentDelegate;



// WEBPACK FOOTER //
// ./src/utilities/DocumentDelegate.js